export default __webpack_public_path__ + "static/media/0020.1cc9042e.WAV";